//# sourceMappingURL=my-date-model.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-date-model.interface.js
// module id = 524
// module chunks = 3